export default __webpack_public_path__ + "static/media/azure.85b5d007.svg";